import createPlotlyComponent from "react-plotlyjs";
import React, { PureComponent } from "react";
import Plotly from "plotly.js/dist/plotly-basic";
import PropTypes from "prop-types";

const PlotlyComponent = createPlotlyComponent(Plotly);

/**
 * Pie chart component displaying in three colors for positive, neutral, and negative
 */
export default class PlotlyPie extends PureComponent {
  render() {
    const values = [this.props.data.positive, this.props.data.negative, this.props.data.neutral];
    const data = [
      {
        values,
        labels: ["Positive", "Negative", "Neutral"],
        type: "pie",
        hole: 0.65,
        marker: {
          colors: ["#69bf75", "#d95f63", "#e7bd3f"],
        },
        textinfo: "none",
        hoverinfo: "label+percent",
        sort: false,
      },
    ];

    const layout = {
      width: 144,
      height: 144,
      margin: {
        l: 10,
        r: 10,
        t: 15,
        b: 10,
      },
      paper_bgcolor: "rgba(0,0,0,0)",
      plot_bgcolor: "rgba(0,0,0,0)",
      showlegend: false,
      annotations: [
        {
          text: `<b>${values[0]}%</b>`,
          font: {
            family: "Roboto",
            size: 20,
          },
          showarrow: false,
          align: "center",
          valign: "middle",
          x: 0.51,
          y: this.props.data.showPrevPositive ? 0.57 : 0.54,
        },
        {
          text: `Positive`,
          font: {
            family: "Roboto",
            size: 11,
          },
          showarrow: false,
          align: "center",
          valign: "middle",
          x: 0.5,
          y: this.props.data.showPrevPositive ? 0.44 : 0.41,
        },
      ],
    };

    if (this.props.data.showPrevPositive) {
      const change = this.props.data.positive - this.props.data.prevPositive;
      layout.annotations.push({
        text: `${Math.abs(change)}%${change > 0 ? " ↑" : change < 0 ? " ↓" : ""}`,
        font: {
          family: "Roboto",
          size: 10,
          color: change > 0 ? "#69bf75" : change < 0 ? "#d95f63" : "#aaa",
        },
        showarrow: false,
        x: 0.51,
        y: 0.28,
      });
    }
    const config = { displayModeBar: false, staticPlot: true };
    return <PlotlyComponent className="whatever" data={data} layout={layout} config={config} />;
  }
}

PlotlyPie.propTypes = {
  /** Array of 3 numbers to display in positive, neutral, and negative donut chart */
  data: PropTypes.arrayOf(PropTypes.number),
};
PlotlyPie.defaultProps = {
  data: [3, 3, 3],
};



// WEBPACK FOOTER //
// ./src/components/plotly/PlotlyPie.jsx